import { createSelector } from "@reduxjs/toolkit";
import { AppSelector } from "../store";
import { IHallOfFameState } from "redux/types/hallOfFame";

const hallOfFameState: AppSelector<IHallOfFameState> = (state) => state.hallOfFameSlice

export const selectHallOfFame = createSelector(hallOfFameState, (top) => top.top)
export const selectMonth = createSelector(hallOfFameState, (month) => month.month)

